import type { StepMap } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { DownloadAppsStep } from "./download-apps-step";
import { IntroVideoStep } from "./intro-video-step";

export const PostImportStepsMap: StepMap = {
  "download-apps": {
    id: "download-apps",
    group: "post-import",
    render: props => <DownloadAppsStep {...props} />,
  },
  "intro-video": {
    id: "intro-video",
    group: "post-import",
    render: props => <IntroVideoStep {...props} />,
  },
} as const;
